import { render, staticRenderFns } from "./guia-formalizacion.vue?vue&type=template&id=391ac6ba&scoped=true&"
import script from "./guia-formalizacion.component.ts?vue&type=script&lang=ts&"
export * from "./guia-formalizacion.component.ts?vue&type=script&lang=ts&"
import style0 from "./guia-formalizacion.vue?vue&type=style&index=0&id=391ac6ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391ac6ba",
  null
  
)

export default component.exports